export const common = {
  add: 'Add',
  apply: 'Apply',
  cancel: 'Cancel',
  clear: 'Clear',
  close: 'Close',
  comingSoon: 'Coming Soon...',
  confirm: 'Confirm',
  create: 'Create',
  creating: 'Creating...',
  dateFormatLocale: 'en-US',
  datePicker: {
    placeholder: 'Select date',
  },
  dateRangePicker: {
    presets: {
      last7Days: 'Last 7 days',
      last30Days: 'Last 30 days',
      last90Days: 'Last 90 days',
      lastMonth: 'Last month',
      monthToDate: 'Month to date',
      yearToDate: 'Year to date',
      custom: 'Custom',
    },
    sections: {
      dateRange: 'Date range',
      compareTo: 'Compare to',
      format: 'Format',
    },
    compare: {
      previousPeriod: 'Previous period',
      previousMonth: 'Same period last month',
      previousYear: 'Same period last year',
      custom: 'Custom',
      goal: 'Objective',
      none: 'No comparison',
    },
    format: {
      percentage: 'Percentage change',
      absolute: 'Absolute change',
    },
    from: 'From',
    to: 'To',
    triggerCompare: 'vs {{label}}',
    editingRange: 'Pick the date range on the calendar',
    editingCompare: 'Pick the comparison range on the calendar',
  },
  delete: 'Delete',
  deleting: 'Deleting...',
  edit: 'Edit',
  error: 'Error',
  errorOccurred: 'An error occurred',
  errors: {
    emailValidation: {
      alreadyTaken: 'Email is already taken',
      invalid: 'Invalid email format',
      validationError: 'Error validating email',
    },
  },
  form: {
    fields: {
      birthdate: {
        error: {
          future: 'Birth date cannot be in the future',
          invalid: 'Invalid date format',
          tooOld: 'Birth date seems too far in the past',
        },
        label: 'Birth Date',
        placeholder: 'Select birth date',
      },
      email: {
        error: {
          required: 'Email is required',
        },
        label: 'Email',
        placeholder: 'john.doe@example.com',
      },
      gender: {
        female: 'Female',
        label: 'Gender',
        male: 'Male',
        other: 'Other',
        placeholder: 'Select gender',
      },
      image: {
        help: 'URL to the image',
        label: 'Image URL',
        placeholder: 'https://example.com/image.jpg',
      },
      lang: {
        english: 'English',
        label: 'Language',
        placeholder: 'Select language',
        portuguese: 'Portuguese',
        spanish: 'Spanish',
      },
      password: {
        editPlaceholder: 'Click regenerate to modify password',
        error: {
          invalid: 'Invalid password',
          mustCopy: 'You must copy the password to continue',
          required: 'Password is required',
        },
        label: 'Password',
        placeholder: 'Enter password',
      },
      phone: {
        label: 'Phone Number',
        placeholder: 'Enter a phone number',
      },
      role: {
        label: 'Role in the application',
        placeholder: 'Select a role',
        required: 'Role is required',
      },
      timezone: {
        detecting: 'Detecting timezone...',
        emptyMessage: 'No timezone found.',
        placeholder: 'Select timezone',
        searchPlaceholder: 'Search timezone...',
      },
    },
  },
  back: 'Back',
  goBack: 'Go Back',
  goHome: 'Go Home',
  language: {
    iso: {
      en: 'English',
      es: 'Spanish',
      pt: 'Portuguese',
      unknown: 'Unknown',
    },
  },
  loading: 'Loading...',
  optional: 'Optional',
  refresh: 'Refresh',
  refreshing: 'Refreshing...',
  restore: 'Restore',
  roles: {
    admin: 'Admin',
    manager: 'Team Leader',
    member: 'Collaborator',
    owner: 'Owner',
    viewer: 'Viewer',
    superadmin: 'Super Admin',
  },
  retry: 'Retry',
  save: 'Save',
  saving: 'Saving...',
  showLess: 'Show Less',
  showMore: 'Show More',
  tags: {
    addTag: 'Add Tag',
    availableTags: 'Available Tags',
    createError: 'Failed to create tag',
    createSuccess: 'Tag created successfully',
    createTag: 'Create "{{tag}}"',
    errorLoadingTags: 'Error loading tags',
    manageTags: 'Manage Tags',
    noTagsFound: 'No tags found',
    searchPlaceholder: 'Search tag...',
  },
  tryAgain: 'Try Again',
  unexpectedError: 'Unexpected error',
} as const
